import {map} from 'rxjs/operators';
import {Injectable, EventEmitter} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import { GlobalDataService } from './services/global-data.service';

@Injectable()
export class GetLIMSDataService {
    expList;
    // baseurl = 'https://shorttc.iodp.tamu.edu:8443'; // for development only
    baseurl = 'https://web.iodp.tamu.edu'; // for production servers
    private first: string;
    private second: string;
    result: string;
    resultReady: EventEmitter<string> = new EventEmitter<string>();

    constructor(private http: HttpClient, public globals: GlobalDataService) {}

    getExpeditions() {
        if (this.expList) {return this.expList; }
        const sampleFilters = `["x_expedition!='QAQC'"]`;
        const url = this.baseurl + `/reference/ExpeditionsGet-DESCreport?samplefilters=` + encodeURIComponent(sampleFilters);
        return this.http.get(url);
    }

    getSites(exp) {
        const url = this.baseurl + `/reference/SitesGet-DESCreport?expedition=${exp}`;
        return this.http.get(url);
    }

    getHoles(exp, site) {
        const myExp = `${exp}`;
        const mySite = `${site}`;
        const sampleFilters = "[\"s.x_expedition='" + myExp + "'\",\"s.x_site='" + mySite + "'\",\"s.sample_type in ('HOLE')\",\"s.status='D'\"]";
        const url = this.baseurl + `/limsM/SamplesGetExp-DESCreport?filloutsamples=1&samplefilters=` + encodeURIComponent(sampleFilters);
        return this.http.get(url).pipe(map(res => {
            const lookup = {};
            const items = Object.values(res);
            items.sort(function (a, b){
                return  a.sample_name  -  b.sample_name ;
            });
            const result = [];

            for ( let i = 0; i < items.length; i++) {
                const item = items[i];
                const sample_name = item.sample_name;

                if (!(sample_name in lookup)) {
                    lookup[sample_name] = 1;
                    result.push(sample_name);
                }
            }
            return result;
        }));
    }

    checkLogin(user, encryptedPassword) {
        // tslint:disable-next-line:max-line-length
        const url = this.baseurl + `/autherW/AuthorizationGet-DESCreport?&username=${user}&password=${encodeURIComponent(encryptedPassword)}`;
        return this.http.get(url)
            .subscribe(
                () => { this.globals.username = user;
                        this.globals.encryptedPassword = encryptedPassword;
                        this.globals.loginError = false;
                        this.globals.showLoginPanel = false;
                },
                () => { this.globals.loginError = true; }
            );
    }

    getReportAssets(exp: string, site: string, hole: string, typeText: string, categoryText: string,
        user: string, encryptedPassword: string) {
        this.getDescRepHeader();
        this.getDescRepDetail(exp, site, hole, typeText, categoryText, user, encryptedPassword);
    }

    getDescRepHeader() {
        const url = this.baseurl + `/limsM/DescReportHeaderGet-DESCREPORT`;
        this.first = '';
        this.http.get(url).subscribe(resp => {
            const length = Object.keys(resp).length;
            let i = 0;
            let text = '<br><br><table style="border: 1px solid black; border-collapse:collapse;">';
            text += '<thead style="background-color:lightgrey; font-weight:bold; border: 1px solid black;"></thead>';
            text += '<tbody style="border: 1px solid black;">';
            text += '<tr style="background-color:lightgrey; font-weight:bold; border: 1px solid black;">';
            for (i = 0; i < length; i++) {
                text += '<td style="padding-left:15px; "><span style="font-weight:bold; font-size: 125%;">' + resp[i] + '</span></td>';
            }
            text += '</tr>';
            this.first = text;
            if (this.first && this.second) {
                this.result = this.first + this.second;
                this.resultReady.emit(this.result);
            }
        });
    }

    getDescRepDetail(exp, site, hole, typeText, categoryText, user, encryptedPassword) {
        let url = '';
        this.second = '';
    // tslint:disable:max-line-length
    // tslint:disable:one-line
        const commonParams = `&type=${encodeURIComponent(typeText)}&category=${encodeURIComponent(categoryText)}&username=${user}&password=${encodeURIComponent(encryptedPassword)}`;
        const myExp = `${exp}`;
        const mySite = `${site}`;
        const myHole = `${hole}`;
        if (!site) {
            const filters = "[\"x_expedition in ('" + myExp + "')\"]";
            url = this.baseurl + `/limsM/DescReportDataGet-DESCREPORT?filters=` + encodeURIComponent(filters) + commonParams;
        } else {
            if (!hole) {
                const filters = "[\"x_expedition in ('" + myExp + "')\", \"x_site in ('" + mySite + "')\"]";
                url = this.baseurl + `/limsM/DescReportDataGet-DESCREPORT?filters=` + encodeURIComponent(filters) + commonParams;
            } else {
                const filters = "[\"x_expedition in ('" + myExp + "')\", \"x_site in ('" + mySite + "')\", \"x_hole in ('" + myHole + "')\"]";
                url = this.baseurl + `/limsM/DescReportDataGet-DESCREPORT?filters=` + encodeURIComponent(filters) + commonParams;
            }
        }
        this.http.get(url).subscribe(resp => {
            const assetCount = Object.keys(resp).length;
            let text = '<span>' + assetCount + ' Assets Returned</span>';
            for (let j = 0; j < assetCount; j++) {
                const reportRow  = resp[j];
                text += '<tr>';
                for (let k = 0; k < reportRow.length; k++) {
                    if (k === 1) {
                        text += '<td> <a style="font-size:125%; padding-left:15px;" href="../filesR/FileGet-DESCReportUI?recordid='
                            + reportRow[k] + '" target="_blank"> '  + reportRow[k] + '</a></td>';
                    } else
                    if (k === 6){
                        text += '<td style="padding-left:15px; "><span style="font-size: 125%;">'
                            + reportRow[k].replace(/,/g, ", ") + '</span></td>';
                    } else
                        {
                        text += '<td style="padding-left:15px; "><span style="font-size: 125%;">'
                            + reportRow[k] + '</span></td>';
                    }
                }
                text += '</tr>';
            }
            text += '</tbody></table>';
            text += '<br>';
            this.second = text;
            if (this.first && this.second) {
                this.result = this.first + this.second;
                this.resultReady.emit(this.result);
            }
        });
    }

    /* private handleError(error: Response) {
        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);
            console.log(' error ' + err);
            console.log(' error body ' + body);
            console.log(' error json ' + JSON.stringify(error));
            const errmsg = '${error.status} - ${error.statusText || ""} ${err}';
            return Promise.reject(errmsg);
        }
        return Promise.reject('failed');
    } */
}
